var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VLayout',{attrs:{"title":_vm.$t('userinformation.personal_data')}},[_c('VAddressForm',{attrs:{"a_uuid":_vm.aUuid},on:{"address-new-updated":_vm.doRedirect}}),_c('VButtonGroup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }